import qs from 'qs';
import { localizeLink, stripOutLocale } from 'client/javascript/util/locale';
import { logError } from 'client/javascript/util/logger';
import { sendBucketEvent } from 'client/javascript/heap';
import { trackInteraction } from 'client/javascript/analytics';
import { acknowledgeAlert, isAlertAcknowledged } from './alert_banner_cookie';
import { geoData } from './geo';

const DISALLOWED_PAGE_URLS = ['/signup', '/waysyouwork'];

const CSS_SELECTORS = {
  ALERT_BANNER_CONTAINER: '.wework-alerts-container',
  ALERT_BANNER_ITEM: '.wework-page-alert',
  ALERT_BANNER_ITEM_EXIT: '.wework-page-alert-exit'
};

const ALERT_BANNER_CLICKED_LABEL = 'Click - Top Banner';

function initAlertBanner(alert) {
  alert.classList.remove('hidden');
  const alertExit = alert.querySelector(CSS_SELECTORS.ALERT_BANNER_ITEM_EXIT);

  initAnalytics(alert);

  if (alertExit) {
    alertExit.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      acknowledgeAlert(alert.id);
      alert.classList.add('hidden');
      alertExit.removeEventListener();
    });
  }
}

export async function displayBanner() {
  await displayPromoBanners();
  const alertsList = document.querySelectorAll(CSS_SELECTORS.ALERT_BANNER_ITEM);
  for (let i = 0; i < alertsList.length; i++) {
    const currentAlert = alertsList[i];
    if (!isAlertAcknowledged(currentAlert.id)) {
      initAlertBanner(currentAlert);
    }
  }
}

async function getPromoAlertBanners() {
  const { countryCode } = await geoData;
  const pageUrlSearchParams = new URLSearchParams(window.location.search);
  const queryParams = {
    we_disable_cf_cache: pageUrlSearchParams.get('we_disable_cf_cache') || false,
    override_treatments: pageUrlSearchParams.get('override_treatments') || false
  };
  const promoAlertBannerEndpointURL = localizeLink({
    to: `/promos-alert-banners/${countryCode}?${qs.stringify(queryParams)}`
  });
  return fetch(promoAlertBannerEndpointURL);
}

async function displayPromoBanners() {
  if (isCurrentPageDisallowed()) {
    return;
  }

  try {
    const response = await getPromoAlertBanners();
    if (!response.ok) {
      return;
    }
    const alertsContainer = document.querySelector(CSS_SELECTORS.ALERT_BANNER_CONTAINER);
    const alerts = await response.text();
    if (alerts !== null) {
      if (hasPromoExperimentBanner(alerts)) {
        sendBucketEvent('alert_banner_link', { triggerHotjar: true, customLabel: 'All Access Promo Banner A/B Test' });
      }
      alertsContainer.insertAdjacentHTML('afterbegin', alerts);
    }
  } catch (error) {
    logError('Failed to fetch Promo banners', error);
  }
}

function hasPromoExperimentBanner(alerts) {
  return alerts.includes('alert-promo-banner');
}

function initAnalytics(alert) {
  alert.addEventListener('click', () => {
    trackInteraction({ label: ALERT_BANNER_CLICKED_LABEL, toPath: alert.href });
  });
}

function isCurrentPageDisallowed() {
  const currentPageURL = stripOutLocale(window.location.pathname) || '';
  return DISALLOWED_PAGE_URLS.find((disallowedPageUrl) => currentPageURL === disallowedPageUrl);
}
